import Controller from "./tag.controller";
import template from "./tag.html";

const tag = {
  template,
  controller: Controller,
};

export default tag;



// WEBPACK FOOTER //
// ./src/pages/tag/tag.component.js